import { render, staticRenderFns } from "./DashboardPrincipal.vue?vue&type=template&id=f576b31e&scoped=true&"
import script from "./DashboardPrincipal.vue?vue&type=script&lang=js&"
export * from "./DashboardPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPrincipal.vue?vue&type=style&index=0&id=f576b31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f576b31e",
  null
  
)

export default component.exports